import React from "react";
import Collapsible from "react-collapsible";
import AddIcon from "@material-ui/icons/Add";
import PortsTable from "./Table";
import { SortOrder } from "../../enums";
import CollapseIcon from "../../assets/images/collapse-collapsible.svg";
import WaveXChangeIcon from "../../assets/images/wavexchange-small-icon.svg";
import Spinner from "../DesignSystem/spinner";
import VerifiedPort from "../../assets/images/port-green.svg";
import UnverifiedPort from "../../assets/images/port-grey.svg";
import ListedPort from "../../assets/images/port-yellow.svg";
import SoldPort from "../../assets/images/port-red.svg";
import { countType } from "../../utils/appConstants";
import Button from "../DesignSystem/button";

interface CollapsibleNEProps {
  id: string;
  text: string;
  open: boolean;
  ports: any[];
  groups: any[];
  loading: boolean;
  order: SortOrder;
  orderBy: string;
  ne: any;
  selected: any[];
  unGroupedSelected: any[];
  selectedUnGroupId: string;
  expandedGroupIds: string[];
  removeLoadingId: string;
  cancelSubLoading: string;
  on_net: boolean;
  unGroupLoading: boolean;
  groupLoading: boolean;
  handleUnGroupClick: () => void;
  handleGroupClick: () => void;
  onSelectRow: (newSelected: any[]) => void;
  onGroupRowSelect: (newSelected: any[], groupId: string) => void;
  onRequestSort: (property: string, nextSortOrder: SortOrder) => void;
  onCollapsibleNEOpen: (neId: string) => void;
  onCollapsibleNEClose: () => void;
  onCollapsibleGroupOpen: (groupId: string) => void;
  onCollapsibleGroupClose: (groupId: string) => void;
  onEditGroupClick: (group: any) => void;
  onSaleClick: (port: any) => void;
  onSaleEdit: (port: any) => void;
  onRemoveClick: (port: any) => void;
  onCancelSubscription: (port: any) => void;
  onEditPort: (port: any) => void;
  onRequestVerification: (port: any) => void;
  refetch: () => void;
}

const CollapsibleNE: React.FC<CollapsibleNEProps> = ({
  ne,
  unGroupLoading,
  refetch,
  onRequestVerification,
  handleGroupClick,
  handleUnGroupClick,
  groupLoading,
  on_net,
  id,
  open,
  text,
  ports,
  groups,
  loading,
  cancelSubLoading,
  selectedUnGroupId,
  order,
  orderBy,
  selected,
  unGroupedSelected,
  expandedGroupIds,
  removeLoadingId,
  onSaleClick,
  onSaleEdit,
  onRemoveClick,
  onCancelSubscription,
  onSelectRow,
  onGroupRowSelect,
  onRequestSort,
  onCollapsibleNEClose,
  onCollapsibleNEOpen,
  onCollapsibleGroupOpen,
  onCollapsibleGroupClose,
  onEditGroupClick,
  onEditPort,
}) => {
  const countObj: countType = ne?.nrCount || {
    verified: 0,
    unverified: 0,
    sold: 0,
    bought: 0,
    listed: 0,
  };

  const trigger = (
    <div className="trigger-div">
      <div>
        <label>
          {on_net ? <img src={WaveXChangeIcon} alt="Company" /> : null}
          {text}
        </label>
        <ul>
          {countObj.verified + countObj.bought > 0 ? (
            <li>
              <img src={VerifiedPort} alt="verified-port" />
              <label>{`${Number(countObj.verified + countObj.bought)}`}</label>
            </li>
          ) : (
            ""
          )}
          {countObj.listed > 0 ? (
            <li>
              <img src={ListedPort} alt="listed-port" />
              <label>{`${countObj.listed}`}</label>
            </li>
          ) : (
            ""
          )}
          {countObj.sold > 0 ? (
            <li>
              <img src={SoldPort} alt="sold-port" />
              <label>{`${countObj.sold}`}</label>
            </li>
          ) : (
            ""
          )}
          {countObj.unverified > 0 ? (
            <li>
              <img src={UnverifiedPort} alt="unverified-port" />
              <label>{`${countObj.unverified}`}</label>
            </li>
          ) : (
            ""
          )}
        </ul>
      </div>
      {open ? <img src={CollapseIcon} alt="Collapse" /> : <AddIcon />}
    </div>
  );

  return (
    <Collapsible
      lazyRender={false}
      open={open}
      transitionTime={150}
      transitionCloseTime={150}
      trigger={trigger}
      onClosing={() => open && onCollapsibleNEClose()}
      onOpening={() => !open && onCollapsibleNEOpen(id)}
    >
      <div className="group-div">
        <Button
          variant="grouped"
          node="Group"
          className="verify-all-btn"
          disabled={!selected || selected.length <= 0}
          loading={groupLoading}
          onClick={handleGroupClick}
        />
        <Button
          variant="grouped"
          node="Ungroup"
          className="verify-all-btn"
          disabled={!unGroupedSelected || unGroupedSelected.length <= 0}
          loading={unGroupLoading}
          onClick={handleUnGroupClick}
        />
      </div>
      <PortsTable
        on_net={on_net}
        onRequestVerification={onRequestVerification}
        onEditPort={onEditPort}
        cancelSubLoading={cancelSubLoading}
        onCancelSubscription={onCancelSubscription}
        onSaleEdit={onSaleEdit}
        onRemoveClick={onRemoveClick}
        removeLoadingId={removeLoadingId}
        onSaleClick={onSaleClick}
        ports={ports}
        groups={groups}
        loading={loading}
        order={order}
        orderBy={orderBy}
        selectedUnGroupId={selectedUnGroupId}
        selected={selected}
        unGroupedSelected={unGroupedSelected}
        expandedGroupIds={expandedGroupIds}
        onSelectRow={onSelectRow}
        onGroupRowSelect={onGroupRowSelect}
        onRequestSort={onRequestSort}
        onCollapsibleGroupOpen={onCollapsibleGroupOpen}
        onCollapsibleGroupClose={onCollapsibleGroupClose}
        onEditGroupClick={onEditGroupClick}
        refetch={refetch}
      />
    </Collapsible>
  );
};

export default CollapsibleNE;
